import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import type {
    OrderGroupId} from "@@/shared/order-groups/order-group-id";
import {
    orderGroupIdZodSchema,
} from "@@/shared/order-groups/order-group-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";

type VerifyStripePaymentCommand = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "VERIFY_STRIPE_PAYMENT_COMMAND";
    readonly orderGroupId: OrderGroupId;
};

type VerifyStripePaymentCommandResponse = {
    readonly _id: string;
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly _type: "VERIFY_STRIPE_PAYMENT_COMMAND_RESPONSE";
};

type CreateCommandProps = Except<
    VerifyStripePaymentCommand,
    "_id" | "_type" | "_createdAt"
>;
type CreateCommandResponseProps = Except<
    VerifyStripePaymentCommandResponse,
    "_id" | "_type" | "_createdAt"
>;
const verifyStripePaymentCommandFactory = (params: CreateCommandProps) => {
    const initiateStripePaymentCommand: VerifyStripePaymentCommand = {
        ...params,
        _id: generateId({ prefix: "verify_stripe_payment_command__" }),
        _type: "VERIFY_STRIPE_PAYMENT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return initiateStripePaymentCommand;
};
const verifyStripePaymentCommandResponseFactory = (
    params: CreateCommandResponseProps,
) => {
    const initiateStripePaymentCommandResponse: VerifyStripePaymentCommandResponse =
        {
            ...params,
            _id: generateId({
                prefix: "verify_stripe_payment_command_response__",
            }),
            _type: "VERIFY_STRIPE_PAYMENT_COMMAND_RESPONSE",
            _createdAt: nowIsoAndUnix(),
        };
    return initiateStripePaymentCommandResponse;
};

const verifyStripePaymentCommandZodSchema: z.ZodSchema<VerifyStripePaymentCommand> =
    z.object({
        _id: idZodSchema,
        _createdAt: isoAndUnixZodSchema,
        _type: z.literal("VERIFY_STRIPE_PAYMENT_COMMAND"),
        orderGroupId: orderGroupIdZodSchema,
    });

export {
    verifyStripePaymentCommandFactory,
    verifyStripePaymentCommandResponseFactory,
    verifyStripePaymentCommandZodSchema,
};
export type { VerifyStripePaymentCommand, VerifyStripePaymentCommandResponse };
